<template>
  <v-dialog v-model="dialog" width="960">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn large icon v-on="{ ...tooltip, ...dialog }">
            <v-icon>mdi-view-column</v-icon>
          </v-btn>
        </template>
        <span>Column Visibility</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-toolbar flat dark color="primary">
        <v-toolbar-title>Column Visibility</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col v-if="tablePresets" cols="3">
            <v-list dense shaped nav>
              <v-subheader>Presets</v-subheader>
              <v-list-item
                v-for="(preset, i) in tablePresets"
                :key="i"
                @click="presetSelected(preset)"
              >
                <v-list-item-content>
                  <v-list-item-title v-html="preset.name"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="9">
            <h2 style="margin-top: 50px; margin-left: -10px">Group Columns</h2>
            <v-row>
              <v-radio-group class="switches">
                <v-switch
                  v-for="column in columns"
                  :key="column"
                  :label="column"
                  :value="column"
                  hide-details="auto"
                  v-model="active"
                ></v-switch>
              </v-radio-group>
            </v-row>
            <h2 style="margin-top: 50px; margin-left: -10px">
              Inner Link Columns
            </h2>
            <v-row
              ><v-radio-group class="switches">
                <v-switch
                  v-for="column in innerColumns"
                  :key="column"
                  :label="column"
                  :value="column"
                  hide-details="auto"
                  v-model="active"
                ></v-switch>
              </v-radio-group>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      active: null,
    };
  },
  mounted() {
    this.init();
    this.active = this.columns;
  },
  props: ["headers", "innerHeaders"],
  watch: {
    active(value) {
      this.$store.dispatch("columnVisibility/setActiveColumns", value);
      this.$emit("columnVisibility", value);
    },
    tableItems() {
      this.init();
    },
  },
  methods: {
    init() {
      let activeColumns = this.columnVisibility.active;
      let defaultPreset = this.columnVisibility.presets
        .map((preset) => {
          if (preset.name === "Default") {
            return preset.active;
          }
        })
        .flat()
        .filter(function(x) {
          return x !== undefined;
        });

      this.active = activeColumns ? activeColumns : defaultPreset;
    },
    presetSelected(preset) {
      switch (preset.name) {
        case "All":
          this.active = this.columns;
          break;
        case "None":
          this.active = [];
          break;
        default:
          this.active = preset.active;
      }
    },
  },
  computed: {
    tableItems() {
      return this.project.items;
    },
    tablePresets() {
      return this.columnVisibility.presets;
    },
    columns() {
      let columns = this.headers.map((col) => col.text);
      return columns;
    },
    innerColumns() {
      let columns = this.innerHeaders.map((col) => col.text);
      return columns;
    },
    ...mapState(["columnVisibility", "project"]),
  },
};
</script>

<style lang="scss">
.switches .v-input--radio-group__input {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
</style>
